<template>
  <div class="carga-global">
    <!-- Barra superior mientras haya peticiones en curso -->
    <div v-if="carga.visible" class="carga-global__barra" />

    <div class="carga-global__avisos">
      <div v-if="carga.visible" class="carga-global__aviso carga-global__aviso--carga">
        <b-spinner small class="mr-50" />
        <span>{{ carga.lento ? 'Está tardando más de lo normal, sigue cargando…' : 'Cargando datos…' }}</span>
      </div>

      <div
        v-for="e in carga.errores"
        :key="e.id"
        class="carga-global__aviso carga-global__aviso--error"
      >
        <feather-icon icon="AlertTriangleIcon" class="mr-50 flex-shrink-0" />
        <span class="carga-global__texto">{{ e.texto }}</span>
        <button type="button" class="carga-global__btn" @click="recargar">Reintentar</button>
        <button type="button" class="carga-global__cerrar" aria-label="Cerrar" @click="quitarError(e.id)">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { carga, quitarError } from '@/libs/cargaGlobal'

export default {
  name: 'CargaGlobal',
  components: { BSpinner },
  data() {
    return { carga }
  },
  methods: {
    quitarError,
    recargar() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.carga-global__barra {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 2000;
  overflow: hidden;
  background: rgba(115, 103, 240, 0.15);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 35%;
    background: #7367f0;
    animation: carga-global-barra 1.1s ease-in-out infinite;
  }
}

@keyframes carga-global-barra {
  0% { left: -35%; }
  100% { left: 100%; }
}

.carga-global__avisos {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: calc(100vw - 32px);
  pointer-events: none;
}

.carga-global__aviso {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.9rem;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
  pointer-events: auto;

  &--carga {
    background: #fff;
    color: #5e5873;
  }

  &--error {
    background: #ea5455;
    color: #fff;
    max-width: 460px;
  }
}

.carga-global__texto {
  word-break: break-word;
}

.carga-global__btn {
  margin-left: 10px;
  padding: 2px 8px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  background: transparent;
  color: #fff;
  font-size: 0.8rem;
  white-space: nowrap;
}

.carga-global__cerrar {
  margin-left: 6px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 1.2rem;
  line-height: 1;
}

.dark-layout .carga-global__aviso--carga {
  background: #283046;
  color: #d0d2d6;
}
</style>
